module.exports = __webpack_public_path__ + "img/vertical_6_7_7005.70263975.png";